var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h32v32H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 7,
    y: 1.5,
    fill: "#FBC1CD",
    rx: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12 16.5 3 3-3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    d: "M3 19.5c0-4.714 0-7.071 1.464-8.535C5.93 9.5 8.286 9.5 13 9.5s7.071 0 8.535 1.464C23 12.43 23 14.787 23 19.5s0 7.071-1.465 8.535C20.072 29.5 17.714 29.5 13 29.5s-7.071 0-8.536-1.465C3 26.572 3 24.214 3 19.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_3.2ee9c37ed8c65aac0a861282f77d755f.svg";